module.exports = __webpack_public_path__ + "img/nature.53f3dd9b.jpg";